import Project from './project'
import { BaseFilter } from './base-filter'


export default class ProjectManager {
  private projects: {};

  public static sortProjects(projectsObj: any,
                             attribute: string,
                             order: string = 'asc') {

    let projects = Object.keys(projectsObj).map(key => projectsObj[key]);
    projects.sort((a, b) => {
      let firstValue = a.getLatestAttribute(attribute);
      let secondValue = b.getLatestAttribute(attribute);
      if (firstValue < secondValue) {
        return -1
      } else {
        return 1
      }
    })
    if (order === 'desc') {
      projects.reverse()
    }
    return projects
  }

  private sortFeaturesBy(features: any[], date: string = 'date_added') {
    features.sort((a, b) => {
      let firstDate = new Date(a.properties[date]);
      let secondDate = new Date(b.properties[date]);
      if (firstDate > secondDate) {
        return -1
      } else {
        return 1
      }
    })
    return features;
  }

  public createProjects(features: any[]) {
    let sortedFeatures = this.sortFeaturesBy(features);
    let projects = {};
    for (let feature of sortedFeatures) {
       let tipId = feature.properties.tip_id
       projects[tipId] = projects[tipId] || new Project(tipId)
       projects[tipId].addFeature(feature);
    }

    for (let id in projects) {
      projects[id].createIndex()
    }
    this.projects = Object.keys(projects).map((projectId) => projects[projectId]);
    return this.projects;
  }

  public getProjects(filters: BaseFilter[]) {
    let filtered = [];
    for (let id in this.projects) {
      let project = this.projects[id];
      let allowed = true;
      for (let filter of filters) {
        if (!filter.filter(project)) {
          allowed = false;
          break;
        }
      }
      if (allowed) filtered.push(project);
    }
    return filtered;
  }

  public getCompleteProjects() {
    return this.projects;
  }
}
